<app-header [showOptions]="false"></app-header>
<div class="flex flex-col items-center justify-center h-[70%]">
  <router-outlet />
</div>
